module.exports = __webpack_public_path__ + "static/media/gente.bdfa66cf.png";